export { default } from './euras-documents';
